// Mobile bottom bar uses a roving tabindex: only one item is in the tab order at a time (tabindex 0), the rest are -1.
// ArrowLeft/ArrowRight (and Home/End) move focus among items;
// Tab/Shift+Tab move to the next focusable outside this bar.
// Parent components own tabindex and call these helpers from keydown/focusin.
//
// Keyboard handling is skipped at desktop widths so it does not fight with normal page focus order.

const MOBILE_BOTTOM_NAV_DESKTOP_MEDIA = '(min-width: 768px)';

export function isMobileBottomNavKeyboardActive(): boolean {
  return typeof window !== 'undefined' && !window.matchMedia(MOBILE_BOTTOM_NAV_DESKTOP_MEDIA).matches;
}

// Ordered list used for roving: primary nav links, then the account menu trigger (if present).
export function getMobileBottomNavFocusables(nav: HTMLElement): HTMLElement[] {
  const links = Array.from(nav.querySelectorAll<HTMLElement>('a.nav-icon-group'));
  const trigger = nav.querySelector<HTMLElement>('button.account-menu__trigger');
  return trigger ? [...links, trigger] : links;
}

export function bottomNavFocusableIndex(active: HTMLElement | null, items: HTMLElement[]): number {
  if (!active) return -1;
  const link = active.closest('a.nav-icon-group');
  const btn = active.matches('button.account-menu__trigger') ? active : null;
  if (link) return items.indexOf(link as HTMLElement);
  if (btn) return items.indexOf(btn);
  return -1;
}

// Returns the next slot index for a recognized key, or null so the caller can leave the event to the browser.
export function nextBottomNavRovingIndex(currentIdx: number, key: string, length: number): number | null {
  if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(key)) return null;
  if (key === 'Home') return 0;
  if (key === 'End') return length - 1;
  if (key === 'ArrowRight') return (currentIdx + 1) % length;
  if (key === 'ArrowLeft') return (currentIdx - 1 + length) % length;
  return null;
}

// Keeps roving state in sync when focus moves.
// Ignores focus inside the account menu overlay so opening the panel does not reset which bar item is considered "current".
export function bottomNavRovingIndexFromFocusTarget(target: HTMLElement | null, items: HTMLElement[]): number | null {
  if (!target || target.closest('.account-menu__overlay')) return null;
  const link = target.closest('a.nav-icon-group');
  const btn = target.closest('button.account-menu__trigger');
  if (link) {
    const i = items.indexOf(link as HTMLElement);
    return i >= 0 ? i : null;
  }
  if (btn) {
    const i = items.indexOf(btn as HTMLElement);
    return i >= 0 ? i : null;
  }
  return null;
}
